import { Button, Tooltip } from "@mantine/core";
import { useMemo } from "react";
import type { EnergyDataImportRequest } from "../../../EnergyDataUploadFlow/EnergyDataUpload";

const SUPPORTED_ERRORS = [
  "Unbekannter Fehler",
  "Die Datei konnte nicht mit der ausgewählten Herkunft verarbeitet werden.",
  "Dieses Format wird aktuell nicht unterstützt. Wir werden es uns anschauen und eventuell implementieren. Um die Daten direkt zu importieren, konvertieren Sie es bitte in unser Template"
];

interface Props {
  file: EnergyDataImportRequest;
  onRequestSupport: (request: EnergyDataImportRequest) => void;
}

function SupportCell({ file, onRequestSupport }: Props) {
  const text = useMemo(() => {
    if (file.supportRequested) {
      return "Eingesendet";
    } else if (
      file.errorMessage &&
      SUPPORTED_ERRORS.includes(file.errorMessage) &&
      !file.supportRequested
    ) {
      return "Anfrage";
    }
  }, [file.errorMessage, file.supportRequested]);

  if (text) {
    return (
      <div>
        <Tooltip
          disabled={!file.supportRequested}
          label={`Ihre Support-Anfrage für ${file.energyDataFile.name} wurde gestellt`}
          openDelay={500}
        >
          <Button
            disabled={file.supportRequested}
            style={{ minWidth: "100%" }}
            onClick={() => onRequestSupport(file)}
          >
            {text}
          </Button>
        </Tooltip>
      </div>
    );
  }

  return <div />;
}

export { SupportCell };
